import formatTableJson from '@younuo/config/tableComponentParams.js'
import { YNColor } from '@younuo/config/StateColorEmun'
export default formatTableJson([
  {
    filed: 'bluetoothMac',
    label: 'MAC地址'
  },
  {
    filed: 'assetNumber',
    label: '设备'
  },
  {
    filed: 'productModel',
    label: '设备型号'
  },
  {
    filed: 'locationAddress',
    label: '设备所在地'
  },
  {
    filed: 'online',
    label: '设备状态',
    type: 'tag',
    colorList: YNColor,
    width: 80,
    formatFn: function (_, row) {
      let dic = {
        online: '在线',
        offline: '离线'
      }
      return dic[row.online]
    }
  }
])
